import React, { FC, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { matchPath } from 'react-router'
import { Grid } from '@mui/material'
import { HeaderOnBoarding } from '../../components/HeaderOnBoarding'
import { clearStepperFormData } from '../../services/clearStepperFormData'
import { FormTabs } from './FormTabs'
import { routes } from '../../constants/routes'

interface ILocationState {
  activeStep: number
}

export const FormStepper: FC = () => {
  const location = useLocation()
  const matchCompany = matchPath(location.pathname, {
    path: routes.COMPANY_ONBOARDING,
  })

  const { state = { activeStep: matchCompany ? 0 : 5 } } = useLocation<ILocationState>()

  const tab = FormTabs[state.activeStep]

  useEffect(() => {
    return () => {
      clearStepperFormData()
    }
  }, [])

  return (
    <>
      <Grid container direction={'column'}>
        <HeaderOnBoarding />
        {tab && <tab.component title={tab.title} />}
      </Grid>
    </>
  )
}
